export default "__VITE_ASSET__PdNKtFIF__"